module.exports = __webpack_public_path__ + "static/media/day17.workshop.f60c2801.md";